<div class="row w-100 py-2">
  <h4>General</h4>
  <table class="details-table col-12 col-lg-7 mb-2">
    <tr>
      <td>Tipo de vehículo:</td>
      <td>{{ vehicleData()?.name ?? 'Cargando...' }}</td>
    </tr>
    <tr>
      <td>Moneda:</td>
      <td>{{ data()?.currency }}</td>
    </tr>
    <tr>
      <td>Tarifa base:</td>
      <td>{{ data()?.baseFee }}</td>
    </tr>
    <tr>
      <td>Coste por Km:</td>
      <td>{{ data()?.costPerKm }}</td>
    </tr>
  </table>
  @if(hasOptionalData()){
  <h4>Extra</h4>
  <table class="details-table col-12 col-lg-7 mb-2">
    @if(data()?.costPerMinute){
    <tr>
      <td>Costo por minuto</td>
      <td>{{ data()?.costPerMinute }}</td>
    </tr>
    } @if(data()?.pickupFee) {
    <tr>
      <td>Costo fijo por recoger:</td>
      <td>{{ data()?.pickupFee }}</td>
    </tr>
    } @if(data()?.dropoffFee){
    <tr>
      <td>Costo fijo por dejar:</td>
      <td>{{ data()?.dropoffFee }}</td>
    </tr>
    } @if(data()?.surgeMultiplier ?? 0 > 1){
    <tr>
      <td>Multiplicador dinámico:</td>
      <td>{{ data()?.surgeMultiplier }}</td>
    </tr>
    } @if(data()?.minimumFare){
    <tr>
      <td>Tarifa mínima total:</td>
      <td>{{ data()?.minimumFare }}</td>
    </tr>
    } @if(data()?.cancellationFee){
    <tr>
      <td>Penalización por cancelación:</td>
      <td>{{ data()?.cancellationFee }}</td>
    </tr>
    } @if(data()?.distanceThresholdKm){
    <tr>
      <td>Distancia base:</td>
      <td>{{ data()?.distanceThresholdKm }}</td>
    </tr>
    }
  </table>
  } @if(hasRuleData()){
  <h4>Regla</h4>
  <table class="details-table col-12 col-lg-7 mb-2">
    @if(data()?.rule?.weekDay?.toString()){
    <tr>
      <td>Día de la semana:</td>
      <td>{{ weekDaysList[data()?.rule?.weekDay ?? -1].label }}</td>
    </tr>
    } @if(data()?.rule?.validTimeRange?.start) {
    <tr>
      <td>Inicio de período de validez:</td>
      <td>{{ data()?.rule?.validTimeRange?.start | date : 'h:mm a' }}</td>
    </tr>
    } @if(data()?.rule?.validTimeRange?.end){
    <tr>
      <td>Fin del período de validez:</td>
      <td>{{ data()?.rule?.validTimeRange?.end | date : 'h:mm a' }}</td>
    </tr>
    } @if(data()?.rule?.geofence){
    <tr>
      <td>Geofence:</td>
      <td>{{ data()?.rule?.geofence }}</td>
    </tr>
    }
  </table>
  }
</div>
